import * as React from 'react';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { useApplicationContext } from '../../../utils/applicationContext';

import { TOpeningPlace } from '../NewbuildingBrokerModalsContext';

export function useMicrofrontEvents(
  microfrontManifest: IMicrofrontendManifest | undefined,
  lastLoadingPlaceRef: React.RefObject<TOpeningPlace | null>,
  loadingPlaceSetter: (type: TOpeningPlace | null) => void,
) {
  const { eventQueue } = useApplicationContext();

  const handleInitialLoadingStart = React.useCallback(
    () => loadingPlaceSetter(lastLoadingPlaceRef.current),
    [lastLoadingPlaceRef, loadingPlaceSetter],
  );
  const handleInitialLoadingEnd = React.useCallback(() => {
    loadingPlaceSetter(null);
  }, [loadingPlaceSetter]);

  React.useEffect(() => {
    if (!microfrontManifest) {
      return;
    }

    eventQueue.on(
      'newbuilding-broker-modals-micro-frontend-reporting.v1.offer-booking-modal-initial-loading::start',
      handleInitialLoadingStart,
    );

    return () =>
      eventQueue.off(
        'newbuilding-broker-modals-micro-frontend-reporting.v1.offer-booking-modal-initial-loading::start',
        handleInitialLoadingStart,
      );
  }, [microfrontManifest, eventQueue, handleInitialLoadingStart]);

  React.useEffect(() => {
    if (!microfrontManifest) {
      return;
    }

    eventQueue.on(
      'newbuilding-broker-modals-micro-frontend-reporting.v1.offer-booking-modal-initial-loading::end',
      handleInitialLoadingEnd,
    );

    return () =>
      eventQueue.off(
        'newbuilding-broker-modals-micro-frontend-reporting.v1.offer-booking-modal-initial-loading::end',
        handleInitialLoadingEnd,
      );
  }, [microfrontManifest, eventQueue, handleInitialLoadingEnd]);
}
